module.exports = __webpack_public_path__ + "static/img/Frame3.bb0f8437.png";